<template>
    <div class="player-intro">
        <img src="@/assets/icons/game-head.png" alt="">
        <div class="about" v-if="$auth.user().user">
            <h2>{{$auth.user().user.user}}</h2>
            <tag :color="matchRoleToColor(userRole)">{{userRole}}</tag>
        </div>
    </div>
</template>

<script>
    import tag from '@/elements/tag.vue'
    import roleToColorMatcher from "@/mixins/roleToColorMatcher";

    export default {
        name: "player_intro",
        mixins: [roleToColorMatcher],
        components:{
            tag,
        },
        computed: {
            userRole() {
                return this.$auth.user().user.group;
            },
        }
    }
</script>

<style scoped lang="scss">
    .player-intro{
        $size: 50px;
        height: $size;
        display: flex;
        img{
            width: $size;
            border-radius: 4px;
        }
        .about{
            margin-left: 16px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;

            h2{
                margin-bottom: 0 !important;
            }
        }
        @include laptop{
            margin-right: 12px;
            h2{
                max-width: 150px;
                overflow: hidden;
            }
        }
    }
</style>